import { Action } from '../action';
import { AuthType } from '../Auth/action';
import { ModalState } from './state';
import { ModalType } from './action';

export const initialState: ModalState = {
    button: null,
    content: null,
    title: '',
    className: undefined,
};

export const modalReducer = (state: ModalState | undefined, action: Action): ModalState => {
    state = state ?? initialState;

    switch (action.type) {
        case ModalType.ModalRequested:
            return { button: action.button, content: action.content, title: action.title, className: action.className };
        case ModalType.ModalClosed:
        case AuthType.TokenExpired:
            return initialState;
        default:
            return state;
    }
};
